// These buckets mirror ApplicationStatusMaster.MISStatus, not approval roles.
export const APPLICATION_DASHBOARD_BUCKETS = {
  DM: [1, 5, 15],
  DBSC: [2],
  PROJECT: [13, 17, 19, 23, 26, 28, 33],
  DGM: [4, 24, 34],
  GM: [20, 30, 32],
  MD: [],
  LOI: [6, 8, 9, 16, 21, 27],
  LAPSED: [10, 25, 29],
  DISBURSED: [22],
  HOLD: [3],
  REJECTED: [7, 14, 18]
};

export function normalizeApplicationLoanType(value) {
  if (value === undefined || value === null || value === "") return 1;
  const loanType = Number(value);
  return [0, 1, 2, 3].indexOf(loanType) !== -1 ? loanType : 1;
}

export function applicationLoanTypes(value) {
  const loanType = normalizeApplicationLoanType(value);
  return loanType === 0 ? [1, 2, 3] : [loanType];
}

export function applicationDashboardStatuses(bucket) {
  const key = String(bucket || "").toUpperCase();
  if (key === "TOTAL") {
    return Object.keys(APPLICATION_DASHBOARD_BUCKETS).reduce((statuses, name) => {
      return statuses.concat(APPLICATION_DASHBOARD_BUCKETS[name]);
    }, []);
  }
  return APPLICATION_DASHBOARD_BUCKETS[key] || null;
}

export function summarizeDashboardApplications(summary, applications, districtView) {
  const seen = new Set();
  const rows = applications.filter(row => {
    if (!row.LoanApplicationID || seen.has(row.LoanApplicationID)) return false;
    seen.add(row.LoanApplicationID);
    return true;
  });
  const columns = {
    DM: "DM", DBSC: "DBSC", Project: "PROJECT", DGM: "DGM", GM: "GM",
    MD: "MD", LOI: "LOI", Lapsed: "LAPSED", Disbursed: "DISBURSED",
    Hold: "HOLD", Rejected: "REJECTED"
  };
  const totalStatuses = applicationDashboardStatuses("TOTAL");
  return summary.map(item => {
    const result = Object.assign({}, item);
    if (districtView) {
      const districtRows = rows.filter(row =>
        item.DistrictName === "TOTAL" || row.DistrictName === item.DistrictName
      );
      Object.keys(columns).forEach(column => {
        result[column] = districtRows.filter(row =>
          APPLICATION_DASHBOARD_BUCKETS[columns[column]].indexOf(Number(row.ApplicationStatusID)) !== -1
        ).length;
      });
      result.Total = districtRows.filter(row => totalStatuses.indexOf(Number(row.ApplicationStatusID)) !== -1).length;
    } else {
      const statusRows = rows.filter(row => Number(item.Id) === 0 || Number(row.ApplicationStatusID) === Number(item.Id));
      ["Individual", "Group", "Education"].forEach((scheme, index) => {
        result["Total" + scheme] = statusRows.filter(row => Number(row.LoanType) === index + 1).length;
      });
    }
    return result;
  });
}



// WEBPACK FOOTER //
// ./src/utils/applicationDashboardFilters.js